const ColorUtil = {
  /**
   * Calculates the YIQ of the color
   * @param {object} rgb The RGB notation of the color
   * @returns {number}
   */
  getYiq({ r, g, b }) {
    return (r * 299 + g * 587 + b * 114) / 1000;
  },

  /**
   * Gets the RGB object notation for a string
   * @param {string} str a string representing a css rgb value
   * @returns {object} an object for rgb notation
   */
  getRGB(str) {
    const match = str.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d\.\d?)\))?/);

    return match ? { r: match[1], g: match[2], b: match[3] } : {};
  }
};
export default ColorUtil;
